export const fncSetStatusNotifications = (state, payload) => {

	state.statusNotificationList = payload;
}

export const fncEmptyStatusNotifications = (state, payload) => {
	state.statusNotificationList = payload;
}

export const fncPopulateStatusCount = (state, payload) => {
	state.statusCount = payload;
}

export const fncSetQuoteStatuses = (state, payload) => {
  state.quoteStatuses = payload;
}

export const fncSetWhatsappTemplates = (state, payload) => {

	payload.unshift({id: '', name: 'No Template'});
	console.log(payload);
  state.whatsappTemplates = payload;
}